import { render, staticRenderFns } from "./dGroupTonesBar.vue?vue&type=template&id=128490cc&"
import script from "./dGroupTonesBar.vue?vue&type=script&lang=js&"
export * from "./dGroupTonesBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports